import Nfc from './components/Nfc';

export default Nfc;

export { Nfc };



// WEBPACK FOOTER //
// ./src/lib/index.js